
































import { Component,	Vue, Watch } from 'vue-property-decorator'

import { bus } from '@/main'
import GlobalMixins from '@/mixins'
import { Languages } from '@/enums'

@Component
export default class SelectBranch extends GlobalMixins {
	selectedBranches: number[] = []

	@Watch('selectedBranches', { deep: true })
	onSelectedBranchesChange() {
		if (this.selectedBranches.length > 0) {
			this.$store.dispatch('setUserPreferredBranches', this.selectedBranches)
		} else {
			this.$store.dispatch('setUserPreferredBranches', false)
		}
		this.updateNextButton()
	}

	@Watch('language', { immediate: true })
	onLanguageChange() {
		this.updateNextButton()
	}

	toggleBranch(branchIndex: number): void {
		if (this.selectedBranches.length < 3 || this.selectedBranches.indexOf(branchIndex) !== -1) {
			if (this.selectedBranches.indexOf(branchIndex) !== -1) {
				this.selectedBranches.splice(this.selectedBranches.indexOf(branchIndex), 1)
			} else {
				this.selectedBranches.push(branchIndex)
			}
		}
	}

	mounted() {
		bus.$on('goToNextScreen', () => {
			this.$router.push({ name: this.language === Languages.NL ? 'criminal-record' : 'criminal-record-'+this.language })
		})
		bus.$on('skipQuestion', () => {
			this.$store.dispatch('setUserPreferredBranches', 'skipped')

			this.$router.push({ name: this.language === Languages.NL ? 'criminal-record' : 'criminal-record-'+this.language })
		})

		if (this.$store.getters.user.preferredBranches && this.$store.getters.user.preferredBranches !== 'skipped') {
			this.selectedBranches = this.$store.getters.user.preferredBranches
		}
	}

	beforeDestroy() {
		bus.$off('goToNextScreen')
		bus.$off('skipQuestion')
	}

	updateNextButton(): void {
		if (this.selectedBranches.length > 0) {
			bus.$emit('setNextButton', {min: this.selectedBranches.length, max: 3, label: this.pageTexts.selectBranch.buttonNext})
		} else {
			bus.$emit('setNextButton', 'skip')
		}
	}
}
